<template>
  <v-card flat outlined class="rounded-10 overflow-y-auto" max-height="85vh">
    <v-card-title>
      <v-icon class="mr-2">mdi-magnify</v-icon>
      Look Up Client
      <v-progress-circular v-if="loading" class="ml-2" indeterminate />
    </v-card-title>
    <v-card-text>
      <v-form @submit.prevent="searchForClients">
        <v-row class="mt-2">
          <v-col cols="7">
            <v-text-field
              v-model="search"
              clearable
              label="Client Name"
              outlined
              class="rounded-lg"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="5" class="d-flex align-center">
            <v-spacer />
            <v-btn class="btn-primary mr-2" @click="searchForClients()">
              Search
            </v-btn>
            <v-btn class="btn-error" @click="clearSearch()"> Clear </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <div
        class="text-center my-10"
        v-if="searched && clientSearch.length === 0"
      >
        No Results for: {{ search }}
      </div>
      <v-simple-table v-if="searched && clientSearch.length > 0">
        <thead>
          <tr>
            <th>Client</th>
            <th>Country</th>
            <th>Contact</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(client, index) in clientSearch"
            :key="index"
            @click="fetchClientSessions(client.uid)"
            style="cursor: pointer"
          >
            <td>
              <strong>{{ client.name }}</strong>
            </td>
            <td>{{ client.country }}</td>
            <td>{{ client.contact }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>

    <v-card-title v-if="searched && clientSessions.length > 0"
      >Sessions</v-card-title
    >
    <v-card-text v-if="searched && clientSessions.length > 0">
      <v-simple-table>
        <thead>
          <tr>
            <th>Reference</th>
            <th>Identity</th>
            <th>Type</th>
            <th>Result</th>
            <th>Kit #</th>
            <th class="text-right">Time</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(session, index) in clientSessions"
            :key="index"
            @click="$emit('open', session)"
            style="cursor: pointer"
          >
            <td>
              <strong>{{ session.reference_number }}</strong>
            </td>
            <td>{{ actorName(session) }}</td>
            <td>{{ session.session_type }}</td>
            <td>
              {{ session.score.toPrecision(4) }}
              <v-chip
                label
                x-small
                color="success"
                v-if="session.score >= thresholds.PASS"
                >Pass</v-chip
              >
              <v-chip
                label
                x-small
                color="error"
                v-else-if="session.score < thresholds.CONSIDER_RESCAN"
                >Fail</v-chip
              >
              <v-chip label x-small color="warning" v-else>Warn</v-chip>
            </td>
            <td>{{ session.kit_serial_number }}</td>
            <td class="text-right">
              {{ session.created_at | luxon({ output: "tz_med" }) }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { THRESHOLDS } from "@osteon-nexus-connect-lib/nc-frontend"
import { prettyIDName } from "@/utils"

export default {
  name: "LookupClient",

  data() {
    return {
      loading: false,
      search: null,
      searched: false
    }
  },

  computed: {
    ...mapGetters(["clientSearch", "clientSessions"]),

    thresholds() {
      return THRESHOLDS
    }
  },

  methods: {
    ...mapActions(["setClientSearch", "setClientSessions"]),

    actorName(session) {
      return prettyIDName(session.actor_payload)
    },

    async searchForClients() {
      this.loading = true
      this.setClientSearch([])
      this.setClientSessions([])
      const response = await this.$axios.post("/proxy/admin/client/search/", {
        keyword: this.search
      })
      this.searched = true
      this.setClientSearch(response.data)
      this.loading = false
    },

    async fetchClientSessions(clientUid) {
      this.loading = true
      const response = await this.$axios.get(
        `/proxy/admin/client/search/${clientUid}`
      )
      this.setClientSessions(response.data)
      this.loading = false
    },

    clearSearch() {
      this.search = null
      this.searched = false
      this.setClientSearch([])
      this.setClientSessions([])
    }
  },

  mounted() {
    if (this.clientSearch?.length || this.clientSessions?.length)
      this.searched = true
  }
}
</script>
